<template>
  <div
    :class="[
      style['alert-container'],
      dismissible ? style['alert-dismissible'] : '',
      hideAlert ? style['alert-hidden'] : ''
    ]"
    role="alert"
  >
    <button
      v-if="dismissible"
      :class="[style['alert-close']]"
      type="button"
      aria-label="Close"
      class="close"
      @click="hideAlert = true"
    >
      ×
    </button>
    {{ alerts }}
  </div>
</template>

<script>
import style from './alert.scss'
export default {
  name: 'TAlert',

  props: {
    alerts: {
      require: true,
      type: String,
      default: ''
    },
    variant: {
      require: false,
      type: String,
      default: 'success'
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      style,
      hideAlert: false
    }
  }
}
</script>
